import { SearchRequester } from "./search-requester";
export { SearchHttpStatusError as GeoSearchHttpStatusError } from "./search-requester";
/**
 * For documentation about this endpoint, see:
 *
 * https://geosearch.planninglabs.nyc/docs/#autocomplete
 *
 */
export const GEO_AUTOCOMPLETE_URL = "https://geosearch.planninglabs.nyc/v2/autocomplete";
/**
 * The keys here were obtained experimentally, I'm not actually sure
 * if/where they are formally specified.
 */
export var GeoSearchBoroughGid;
(function (GeoSearchBoroughGid) {
    GeoSearchBoroughGid["Manhattan"] = "whosonfirst:borough:421205771";
    GeoSearchBoroughGid["Bronx"] = "whosonfirst:borough:421205773";
    GeoSearchBoroughGid["Brooklyn"] = "whosonfirst:borough:421205765";
    GeoSearchBoroughGid["Queens"] = "whosonfirst:borough:421205767";
    GeoSearchBoroughGid["StatenIsland"] = "whosonfirst:borough:421205775";
})(GeoSearchBoroughGid || (GeoSearchBoroughGid = {}));
/**
 * This class can be used to issue NYC Planning Labs GeoSearch requests
 * based on a query whose value may change over time
 * due to e.g. keyboard input.
 */
export class GeoSearchRequester extends SearchRequester {
    constructor(options) {
        super(options);
        this.options = options;
    }
    searchQueryToURL(query) {
        return `${this.options.customGeoAutocompleteUrl || GEO_AUTOCOMPLETE_URL}?text=${encodeURIComponent(query)}`;
    }
}
/**
 * A convenience function for making NYC Planning Labs GeoSearch
 * requests outside the context of an autocomplete UI: provide
 * an address, and this function will return results.
 */
export function geoSearch(address, options) {
    return new Promise((resolve, reject) => {
        const req = new GeoSearchRequester({
            ...options,
            onError: reject,
            onResults: resolve,
            throttleMs: 0,
        });
        req.changeSearchRequest(address);
    });
}
//# sourceMappingURL=geosearch-requester.js.map